import { render, staticRenderFns } from "./portlet.vue?vue&type=template&id=32c86614&"
import script from "./portlet.vue?vue&type=script&lang=js&"
export * from "./portlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports